import { Link, Typography } from "@mui/material";
import { UiContainer } from "@ory/kratos-client";
import { FieldValues } from "react-hook-form";
import { UiForm, UiFormProps } from "../../../components";

export interface PasswordFormProps<T extends FieldValues> {
  handleSubmit: UiFormProps<T>["handleSubmit"];
  ui: UiContainer;
}

export const PasswordForm = <T extends FieldValues>({
  handleSubmit,
  ui,
}: PasswordFormProps<T>) => {
  return (
    <>
      <UiForm
        handleSubmit={handleSubmit}
        ui={ui}
        groups={["password"]}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          ".MuiButton-outlinedPrimary": {
            color: "shades.dark",
          },
        }}
        buttonVariant="outlined"
      />
      <Typography
        align="center"
        sx={{
          marginTop: "16px",
          fontWeight: 700,
          fontSize: "14px",
          lineHeight: "20px",
        }}
      >
        <Link
          href="/login/recovery"
          sx={(theme) => ({
            color: theme.palette.grey[600],
            textDecoration: "underline",
            "&:hover": {
              color: theme.palette.grey[800],
              textDecoration: "underline",
            },
          })}
        >
          Zaboravljena lozinka?
        </Link>
      </Typography>
    </>
  );
};
